// extracted by mini-css-extract-plugin
export default {"wrapper":"StoriesBar_wrapper__OLrJF","thumb":"StoriesBar_thumb__D5kjk","thumb__skeleton":"StoriesBar_thumb__skeleton__bLw2p"};